export function processFirstWordsText(text, wordsToUse, inverseSelection) {
    let parts = text.split(' ')
    let numberOfWordsInText = parts.length

    if (inverseSelection) {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let invertedWordsToTake = numberOfWordsInText - wordsToUse
            let backwardsIterator = numberOfWordsInText - 1
            let words = []
            for (let i = 0; i < invertedWordsToTake; i++) {
                words.push(parts[backwardsIterator])
                backwardsIterator--
            }
            words.reverse()
            let rtnVal = words.join(" ")
            return rtnVal
        }
    } else {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let words = []
            for (let i = 0; i < wordsToUse; i++) {
                words.push(parts[i])
            }
            let rtnVal = words.join(" ")
            return rtnVal
        }
    }
}

export function processLastWordsText(text, wordsToUse, inverseSelection) {
    let parts = text.split(' ')
    let numberOfWordsInText = parts.length

    if (inverseSelection) {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let invertedWordsToTake = numberOfWordsInText - wordsToUse
            let words = []
            for (let i = 0; i < invertedWordsToTake; i++) {
                words.push(parts[i])
            }
            let rtnVal = words.join(" ")
            return rtnVal
        }
    } else {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let words = []
            let wordsAdded = 0
            let wordIndex = numberOfWordsInText - 1
            while (wordsAdded < wordsToUse) {
                words.push(parts[i])
                wordsAdded++
                wordIndex--
            }
            for (let i = numberOfWordsInText - 1; i > 0; i--) {
                words.push(parts[i])
            }
            words.reverse()
            let rtnVal = words.join(" ")
            return rtnVal
        }
    }
}

export function processFirstWordsAfterFirstNumberOfWordsText(text, wordsToUse, inverseSelection, after) {
    let parts = text.split(' ')
    let numberOfWordsInText = parts.length

    if (after < 0) {
        return text
    }

    if (inverseSelection) {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let invertedWordsToTake = numberOfWordsInText - wordsToUse
            let backwardsIterator = numberOfWordsInText - 1
            let afterIterator = 0
            let words = []
            for (let i = 0; i < invertedWordsToTake; i++) {
                if (afterIterator > after) {
                    words.push(parts[backwardsIterator])
                }
                backwardsIterator--
                afterIterator++
            }
            words.reverse()
            let rtnVal = words.join(" ")
            return rtnVal
        }
    } else {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let words = []
            for (let i = after; i < numberOfWordsInText; i++) {
                words.push(parts[i])
            }
            let rtnVal = words.slice(0, wordsToUse).join(" ")
            return rtnVal
        }
    }
}

export function processFirstWordsAfterLastNumberOfWordsText(text, wordsToUse, inverseSelection, after) {
    let parts = text.split(' ')
    let numberOfWordsInText = parts.length

    if (after < 0) {
        return text
    }

    if (inverseSelection) {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let words = []
            let finalWords = []
            for (let i = after; i < numberOfWordsInText; i++) {
                words.push(parts[i])
            }
            for (let i = 0; i < wordsToUse; i++) {
                finalWords.push(words[i])
            }
            let rtnVal = finalWords.join(" ")
            return rtnVal
        }
    } else {
        if (wordsToUse > numberOfWordsInText) {
            return text
        } else {
            let invertedWordsToTake = numberOfWordsInText - wordsToUse
            let backwardsIterator = numberOfWordsInText - 1
            let afterIterator = 0
            let words = []
            let finalWords = []
            for (let i = 0; i < invertedWordsToTake; i++) {
                if (afterIterator > after) {
                    words.push(parts[backwardsIterator])
                }
                backwardsIterator--
                afterIterator++
            }
            for (let i = 0; i < wordsToUse; i++) {
                finalWords.push(words[i])
            }
            let rtnVal = finalWords.join(" ")
            return rtnVal
        }
    }
}

export function processFirstWordsBeforeOccurence(text, wordsToUse, inverseSelection, occurence) {
    let parts = text.split(' ')
    let numberOfWordsInText = parts.length
    let firstOccurrence = -1

    for (let x = 0; x < numberOfWordsInText; x++) {
        if (parts[x] === occurence) {
            firstOccurrence = x
        }
    }

    if (inverseSelection) {
        if (!occurence || !occurence.trim()) {
            if (wordsToUse > numberOfWordsInText) {
                return ''
            } else {
                if (firstOccurrence < wordsToUse) {
                    return ''
                } else if (firstOccurrence > 0) {
                    let listParts = []
                    for (let x = 0; x < parts.length; x++) {
                        if (x >= firstOccurrence) {
                            listParts.push(parts[x])
                        }
                    }
                    let rtnVal = listParts.join(" ")
                    return rtnVal
                } else {
                    return ''
                }
            }
        } else {
            if (wordsToUse > numberOfWordsInText) {
                return ''
            } else {
                if (firstOccurrence < wordsToUse) {
                    return ''
                } else if (firstOccurrence > 0) {
                    let listParts = []
                    for (let x = 0; x < parts.length; x++) {
                        if (x >= firstOccurrence) {
                            listParts.push(parts[x])
                        }
                    }
                    let rtnVal = listParts.join(" ")
                    return rtnVal
                } else {
                    return ''
                }
            }
        }
    } else {
        if (!occurence || !occurence.trim()) {
            if (wordsToUse > numberOfWordsInText) {
                return ''
            } else {
                let finalWords = []
                for (let i = 0; i < wordsToUse; i++) {
                    finalWords.push(parts[i])
                }
                let rtnVal = finalWords.join(" ")
                return rtnVal
            }
        } else {
            if (firstOccurrence === -1) {
                return ''
            } else {
                if (wordsToUse > firstOccurrence) {
                    return ''
                } else {
                    let finalWords = []
                    for (let i = 0; i < wordsToUse; i++) {
                        finalWords.push(parts[i])
                    }
                    let rtnVal = finalWords.join(" ")
                    return rtnVal
                }
            }
        }
    }

    return text
}

export function processRegularExpressionText(text, expressionTerm, expressionOutput) {
    try {
        if (!expressionOutput || !expressionOutput.trim()) {
            return text
        }
        
        let processedValue = expressionOutput
        let totalLineRegex = new RegExp(expressionTerm)
        let regexMatches = text.match(totalLineRegex)

        if (regexMatches && regexMatches.length > 0) {
            console.log(regexMatches)
            for (let matchIndex = regexMatches.length-1; matchIndex >= 0; matchIndex--) {
                let currentIndex = `(${matchIndex})`
                processedValue = processedValue.replace(currentIndex, regexMatches[matchIndex])
            }
            return processedValue
        }
    
        return ''
    } catch {
        return ''
    }
}

export function getNewOutputFormat(text) {
    try {
        let bracketRegex = /\(.*?\)/g
        let matches = text.match(bracketRegex)
        let indexes = []

        for (let i = 0; i < matches.length; i++) { 
            indexes.push(`(${i+1})`)
        }
        
        return indexes.join(" ")
    } catch {
        return ''
    }
}

export function processDateExpression(text, type) {
    const regex = /(?:Ending\s+|END\s+)(\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{1,2}(?:st|nd|rd|th)?,\s+\d{4})/i
    const match = text.match(regex)

    if (match) {
        let parsed = parseDate(match[1])
        if (type === 0) {
            return parsed.getFullYear().toString()
        } else if (type === 1) {
            return (parsed.getMonth()+1).toString()
        } else if (type === 2) {
            return parsed.getDate().toString()
        } else if (type === 3) {
            return formatDate(parsed)
        }
    }
    
    return ''
}

function parseDate(str) {
    // Parse the string as a date
    const timestamp = Date.parse(str)

    // If the result is NaN, return null
    if (isNaN(timestamp)) {
        return null
    }

    // Create a Date object using the parsed timestamp
    return new Date(timestamp)
}

function formatDate(date) {
    // Get year, month, and day from the Date object
    const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const month = padZero(date.getMonth() + 1); // Month is zero-based, so add 1
    const day = padZero(date.getDate());

    // Concatenate year, month, and day with '/'
    return `${year}/${month}/${day}`;
}

function padZero(num) {
    // Add leading zero if the number is less than 10
    return num < 10 ? `0${num}` : num;
}